module.exports = __webpack_public_path__ + "static/media/18ECA13.87d4f5ac.jpg";